export enum DiscountStatuses {
  Used = 'used',
  Valid = 'valid',
  Invalid = 'invalid',
  Expired = 'expired',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Returned = 'returned'
}

export enum DiscountSources {
  OnlineOrder = 'onlineOrder',
  OfflineOrder = 'offlineOrder',
  WelcomeGift = 'WelcomeGift',
  Campaign = 'campaign'
}

export enum DiscountTypeEnum {
  Monetary = 'monetary',
  Percentage = 'percentage'
}
